import { createResourceReducer, typedResourceService } from './resourceReducer'

const { reducer, actions, thunks } = createResourceReducer({
    sliceName: 'books',
    label: 'Book',
    service: typedResourceService('Book'),
})

export const { appendResource: appendBook, destroyResource: destroyBook, changeResource: changeBook } = actions
export const { createResource: createBook, initializeResources: initializeBooks, deleteResource: deleteBook, updateResource: updateBook, searchResources: searchBooks, refreshResource: refreshBook } = thunks

export default reducer
